import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  CONTACTS_REQUEST,
  CONTACTS_SUCCESS,
  CONTACTS_FAILED,
  CONTACTS_CREATE,
  CONTACTS_CREATE_SUCCESS,
  CONTACTS_CREATE_FAILED,
  CONTACTS_DELETE,
  CONTACTS_DELETE_SUCCESS,
  CONTACTS_DELETE_FAILED,
  CONTACTS_EDIT,
  CONTACTS_EDIT_SUCCESS,
  CONTACTS_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * Contacts Actions
 */

function* fetchContacts({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/Contact/GetContact`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: CONTACTS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: CONTACTS_FAILED, payload: error.response });
    }
  }
}

function* createContacts(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/Contact/CreateContact`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: CONTACTS_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CONTACTS_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editContacts(action) {
  try {
    const response = yield call(
      axios.put,
      `${API_URL}/Product/api/Contact/UpdateContact`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: CONTACTS_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CONTACTS_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteContacts(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/Contact/RemoveContact?ContactsId=${encodeURIComponent(action.payload.ContactsId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: CONTACTS_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CONTACTS_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootContactsList() {
  yield all([
    takeLatest(CONTACTS_REQUEST, fetchContacts),
    takeLatest(CONTACTS_CREATE, createContacts),
    takeLatest(CONTACTS_DELETE, deleteContacts),
    takeLatest(CONTACTS_EDIT, editContacts),
  ]);
}